import React from 'react'

const container = (props) => {
  return (
    <div className='container-lg'>
        {props.children}
    </div>
  )
}

export default container